module.exports = __webpack_public_path__ + "images/emoji/mailbox_with_mail.7c8d4edcf69bb3ae463c.png";